<template>
  <div class="full-screen">
    <img
      v-if="isPhoto"
      :src="imageUrl"
      :width="photo.width"
      :height="photo.height"
    />

    <video
      v-else-if="isVideo"
      ref="video"
      autoplay
      playsinline
      muted
      loop
      controls
      :width="photo.width"
      :height="photo.height"
    >
      <source :src="videoUrl" :type="photo.mimetype" />
    </video>
  </div>
</template>

<script setup lang="ts">
import type { Photo } from "~/api";

const video: Ref<HTMLVideoElement | null> = ref(null);

const props = defineProps({
  photo: {
    type: Object as PropType<Photo>,
    required: true,
  },

  visible: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
});

const { photo, visible } = toRefs(props);
const { isPhoto, isVideo, imageUrl, videoUrl } = usePhoto(photo.value, 2400);

const playVideo = () => video.value?.play();
const pauseVideo = () => video.value?.pause();

watch(visible, (isVisible) => {
  if (isVideo.value) {
    if (isVisible) {
      playVideo();
    } else {
      pauseVideo();
    }
  }
});
</script>

<style scoped lang="postcss">
.full-screen {
  @apply absolute inset-2;

  img,
  video {
    @apply object-contain;
    @apply w-full h-full;
  }
}
</style>
